import { render, staticRenderFns } from "./deviceParam.vue?vue&type=template&id=482778d2&scoped=true&"
import script from "./deviceParam.vue?vue&type=script&lang=js&"
export * from "./deviceParam.vue?vue&type=script&lang=js&"
import style0 from "./deviceParam.vue?vue&type=style&index=0&id=482778d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482778d2",
  null
  
)

export default component.exports